<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="115px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="服务网点" prop="nursinghomeId">
              <el-select
                disabled
                v-model="form.nursinghomeId"
                style="width: 100%"
                placeholder="服务网点"
                @change="nursinghomeIdChange"
              >
                <el-option
                  v-for="item in nursinghomeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备编号" prop="code">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.code"
                placeholder="设备编号"
                maxlength="7"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备名称" prop="name">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.name"
                placeholder="设备名称"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备IMEI号" prop="deviceSerial">
              <el-input
                clearable
                :disabled="model === 'view'"
                v-model="form.deviceSerial"
                placeholder="设备IMEI号"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属设备大类" prop="deviceCategory">
              <el-select
                disabled
                v-model="form.deviceCategory"
                style="width: 100%"
                placeholder="请选择所属设备大类"
                @change="userIdChange"
              >
                <el-option
                  v-for="item in deviceCategoryList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="设备类型" prop="deviceTypeId">
              <el-select
                :disabled="model != 'add'"
                v-model="form.deviceTypeId"
                style="width: 100%"
                placeholder="设备类型"
                @change="deviceTypeIdChange"
              >
                <el-option
                  v-for="item in deviceTypeIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="设备型号" prop="deviceModelId">
              <el-select
                :disabled="model === 'view'"
                v-model="form.deviceModelId"
                style="width: 100%"
                placeholder="设备类型"
                @change="deviceModelIdChange"
              >
                <el-option
                  v-for="item in deviceModelIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="设备厂家" prop="vendor">
              <el-input
                clearable
                disabled
                v-model="form.vendor"
                placeholder="设备厂家"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="出厂时间" prop="leaveFactoryTime">
              <el-date-picker
                :disabled="model === 'view'"
                v-model="form.leaveFactoryTime"
                style="width: 100%;"
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                placeholder="请选择出厂时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="购入时间" prop="buyingTime">
              <el-date-picker
                :disabled="model === 'view'"
                v-model="form.buyingTime"
                type="date"
                value-format="yyyy-MM-dd 00:00:00"
                style="width: 100%;"
                placeholder="请选择购入时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="厂家保修期" prop="guaranteeEndTime">
              <el-date-picker
                :disabled="model === 'view'"
                v-model="form.guaranteeEndTime"
                type="date"
                style="width: 100%;"
                value-format="yyyy-MM-dd 00:00:00"
                placeholder="请选择厂家保修期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="所属应用场景" prop="applicationScene">
              <el-select
                :disabled="model === 'view'"
                v-model="form.applicationScene"
                style="width: 100%"
                placeholder="请选择所属应用场景"
              >
                <el-option
                  v-for="item in senceList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="安装位置" prop="installAddr">
              <el-input
                :disabled="model === 'view'"
                maxlength="200"
                type="text"
                placeholder="请输入安装位置"
                v-model="form.installAddr"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="备注" prop="description">
              <el-input
                :disabled="model === 'view'"
                maxlength="500"
                type="textarea"
                :rows="2"
                placeholder="请输入备注"
                v-model="form.description"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="设备图片" prop="attachList">
              <vUpload
                :disabled="model == 'view'"
                :message="'提示：上传文件不大于12MB，数量最多3张'"
                :types="['jpg', 'png']"
                :max="12 * 1024 * 1024"
                :limit="3"
                :fileList.sync="form.attachList"
              ></vUpload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        {{ model == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import {
  getMatetial,
  getNursinghome,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
  getNursingList,
  getDeviceTypeList,
  getDeviceModelList,
  saveWristband,
  getBasicInforDetail,
  updateWristband,
} from '../api/serveItemManage';
import vUpload from '../components/mutil-upload.vue';
import {
  smartDeviceSave,
  smartDeviceUpdate,
  getSmartDeviceDetail,
  modelListByTypeId,
} from '@/api/nursingHome/elderDevice';
export default {
  components: { vUpload },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      projectList: [],
      provideList: [],
      form: {
        nursinghomeId: '',
        code: '',
        name: '',
        deviceCategory: '2',
        attachList: [],
        deviceModelId: '',
        deviceTypeId: '',
        deviceSerial: '',
        vendor: '',
        leaveFactoryTime: '',
        buyingTime: '',
        guaranteeEndTime: '',
        description: '',
        applicationScene: '',
        installAddr: '',
      },
      formRules: {
        nursinghomeId: [{ required: true, message: '服务网点不能为空', trigger: 'change' }],

        code: [{ required: true, message: '设备编号不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '设备名称不能为空', trigger: 'blur' }],
        deviceCategory: [{ required: true, message: '所属设备大类不能为空', trigger: 'change' }],

        deviceTypeId: [{ required: true, message: '设备类型不能为空', trigger: 'change' }],
        deviceSerial: [{ required: true, message: '设备IMEI号不能为空', trigger: 'blur' }],

        guaranteeEndTime: [{ required: true, message: '厂家保修期不能为空', trigger: 'change' }],
      },
      matetialList: [],
      deviceCategoryList: [],
      userList: [],
      deviceTypeIdList: [],
      deviceModelIdList: [],
      nursinghomeIdList: [],
      paymentTypeList: [],
      senceList: []
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    deviceModelIdChange() {
      this.deviceModelIdList.forEach((item) => {
        if (item.id == this.form.deviceModelId) {
          this.form.vendor = item.manufacturerName;
        }
      });
    },
    deviceTypeIdChange() {
      this.deviceModelIdList = [];
      this.form.deviceModelId = '';
      if (this.form.deviceTypeId != '') {
        modelListByTypeId({ id: this.form.deviceTypeId }).then((res) => {
          this.deviceModelIdList = res.data;
        });
      }
    },
    async initData() {
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
      });
      getNursingList({ id: this.nursinghomeId }).then((res) => {
        this.userList = res.data;
      });
      getDictionary('nursinghome_device_category').then((res) => {
        this.deviceCategoryList = res.data;
      });
      getDictionary('nursinghome_payment_type').then((res) => {
        this.paymentTypeList = res.data;
      });

      getDictionary('nursinghome_release_mode_type').then((res) => {
        this.provideList = res.data;
      });

      getDictionary('application_scene').then((res) => {
        this.senceList = res.data;
      });

      if (this.model === 'add') {
        this.form.nursinghomeId = this.nursinghomeId;
        getDeviceTypeList({
          id: this.form.nursinghomeId,
          deviceCategory: this.form.deviceCategory,
        }).then((res) => {
          this.deviceTypeIdList = res.data;
        });
      } else {
        getSmartDeviceDetail({ id: this.row.id }).then((res) => {
          this.form = res.data;
          this.form.deviceCategory += '';
          getDeviceTypeList({
            id: this.form.nursinghomeId,
            deviceCategory: this.form.deviceCategory,
          }).then((res) => {
            this.deviceTypeIdList = res.data;
          });
          modelListByTypeId({ id: this.form.deviceTypeId }).then((res) => {
            this.deviceModelIdList = res.data;
          });
        });
      }
    },
    saveRecord() {
      console.log(this.form);
      if (this.model === 'add') {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            smartDeviceSave(this.form).then((res) => {
              this.$message.success('新增成功');
              this.$emit('success');
            });
          }
        });
      } else {
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            smartDeviceUpdate(this.form).then((res) => {
              this.$message.success('修改成功');
              this.$emit('success');
            });
          }
        });
      }
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
